import React, { Component } from 'react';
import './CustomTooltip.scss';
export default class Customtooltip extends Component {

    getReactContainerClasses() {
        let  noneToolTiparray=["BookMarkIcon","FolderIcon","OpenInNewTabIcon"];
        if(noneToolTiparray.includes(this.props.colDef.field))
        return null;
        else
        return ['ag-custom-tooltip'];


    }
    render() {
        let  noneToolTiparray=["BookMarkIcon","FolderIcon","OpenInNewTabIcon"];
        var props = this.props;
        const data = this.props && this.props.context && this.props.context.componentParent && this.props.context.componentParent.props?this.props.context.componentParent.props.rowData:[];
        const selectedRows = this.props && this.props.context && this.props.context.componentParent && this.props.context.componentParent.props?this.props.context.componentParent.props.selectedRows:[];
        return (
        props.value ? 
        <div className="div-style">
            <span className="tooltiptext" >{props.value}</span> 
        </div>
                
            : props.colDef.field === 'checkboxIcon' && !noneToolTiparray.includes(props.colDef.field) ? data.length === selectedRows.length ?
            <div className="div-style">
                <span className="tooltiptext" >Deselect All</span> 
            </div>
            :
            <div className="div-style">
                <span className="tooltiptext" >Select All</span>
            </div>
            : null


        )

    }
}
